import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from './application/security/auth-guard.service';
import {LoginComponent} from './interfaces/pages/login/login.component';
import {HomeComponent} from './interfaces/pages/home/home.component';
import {LogoutComponent} from './interfaces/pages/logout/logout.component';

const routes: Routes = [
  {path: '', component: LoginComponent, canActivate: [AuthGuard]},
  {path: LogoutComponent.LOGOUT_URL, component: LogoutComponent},
  {path: LoginComponent.LOGIN_URL, component: LoginComponent, canActivate: [AuthGuard]},
  {path: HomeComponent.HOME_URL, component: HomeComponent},
  {path: '**', redirectTo: HomeComponent.HOME_URL, canActivate: [AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
